import {all} from "redux-saga/effects";

import profile from "./pages/profile/saga";
import materials from "./pages/materials/saga";
import screening from "./pages/screening/saga";
import articles from "./pages/articles/saga";

export default function* rootSaga(){
  yield all([
    profile(),
    materials(),
    screening(),
    articles(),
  ])
}